import {FC} from 'react'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {Text} from '@/components/ui/text/Text'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {InputSelectUser} from '@/features/users/components/input-select-user/InputSelectUser'
import {Controller, useFormContext} from 'react-hook-form'
import {AddConsultantAbsenceFormValidationSchema} from '../../formSchemas'
import {useTranslation} from '@/translations/i18n'
import {absenceReasonToLabel} from '@/features/users/utils'
import {AddConsultantAbsenceDateTimeFields} from '../add-consultant-absence-date-time-fields/AddConsultantAbsenceDateTimeFields'

export const AddConsultantAbsenceFields: FC = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<AddConsultantAbsenceFormValidationSchema>()

    return (
        <Grid columns={2} columnGap={4} rowGap={6} fullWidth>
            <GridItem spanColumn={2}>
                <Controller
                    control={control}
                    name="consultant"
                    render={({field, fieldState}) => (
                        <InputSelectUser
                            value={field.value || null}
                            onChange={field.onChange}
                            placeholder={t('agenda:select_consultant')}
                            errorMessage={fieldState.error?.message}
                        />
                    )}
                />
            </GridItem>

            <AddConsultantAbsenceDateTimeFields />

            <GridItem spanColumn={2}>
                <Flexbox direction="column" gap={1.5} fullWidth>
                    <Text palette="neutral" shade="900" size="textSm" weight="500">
                        {t('agenda:reason')}
                    </Text>
                    <Controller
                        control={control}
                        name="absenceReason"
                        render={({field, fieldState}) => (
                            <InputSelect
                                placeholder={t('agenda:select_reason')}
                                optionsMap={absenceReasonToLabel}
                                onChange={field.onChange}
                                value={field.value}
                                onClear={() => field.onChange(null)}
                                errorMessage={fieldState.error?.message}
                            />
                        )}
                    />
                </Flexbox>
            </GridItem>
        </Grid>
    )
}
